var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ed2969585085bde14ea85e5bb17bc91d.js').default;export default
        Object.assign({}, scope_0 )
    